











import { defineComponent, computed, ref, getCurrentInstance } from '@vue/composition-api';
import { userRole } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const vm = getCurrentInstance()?.proxy || context.root;
    const role = ref('user');
    const roleOptions = Object.keys(userRole)
      .filter(key => !['superAdmin', 'teamAdmin'].includes(key))
      .map(key => ({
        label: userRole[key],
        value: key,
      }));
    const methods = {
      confirm() {
        context.emit('submit', role.value);
      },
    };
    return {
      innerShow,
      roleOptions,
      role,
      ...methods,
    };
  },
});
